import React, { Component } from "react";
import PropTypes from "prop-types";
import "./SwitchButton.scss";

class SwitchButton extends Component {
  static propTypes = {
    isChecked: PropTypes.bool,
    handleChange: PropTypes.func
  };

  static defaultProps = {
    isChecked: false,
    handleChange: () => {}
  };

  render() {
    const { isChecked, handleChange } = this.props;
    return (
      <div className="switch-button">
        <label>
          <input
            checked={isChecked}
            value={isChecked}
            onChange={handleChange}
            className="switch"
            type="checkbox"
          />
          <div>
            <span>
              <g className="icon icon-toolbar grid-view" />
            </span>
            <span>
              <g className="icon icon-toolbar ticket-view" />
            </span>
            <div />
          </div>
        </label>
      </div>
    );
  }
}

export default SwitchButton;
